import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IArticleTracking, ITracking, ITrackingSummaries } from "./types/_tracking";
const api = new APIClient();

const path = '/news-trackings';
const trackingApi = {
  articleTrackings(params: any): Promise<AxiosResponse<ResponseData<IArticleTracking[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  summariesArticleTrackings(params: any): Promise<AxiosResponse<ResponseData<IArticleTracking[]> & PaginationResponse, any>> {
    const url = `${path}/summaries`
    return api.get(url, params)
  },
  downloadExcelTrackingNews(params: any): Promise<AxiosResponse<ResponseData<IArticleTracking[]> & PaginationResponse, any>> {
    const url = `${path}/export`
    return api.get(url, params)
  },
  trackingLogs(params: any): Promise<AxiosResponse<ResponseData<ITracking[]> & PaginationResponse, any>> {
    const url = `/ads-logs`
    return api.get(url, params)
  },
  downloadExcelTrackingLogs(params: any): Promise<AxiosResponse<ResponseData<ITracking[]> & PaginationResponse, any>> {
    const url = `/ads-logs`
    return api.get(url, params)
  },
  trackingSummariesLogs(params: any): Promise<AxiosResponse<ResponseData<ITrackingSummaries[]> & PaginationResponse, any>> {
    const url = `/ads-logs/summaries`
    return api.get(url, params)
  },
}
export default trackingApi
